import React from 'react';
import {MenuItem} from "@sendbird/uikit-react/ui/MessageMenu";
import useBrowserLanguage, {languageMap} from '../utils/useBrowserLanguage';
import {scrollToBottom} from "../utils/messageUtils";

export const TranslateMenuItem = ({message, channel}) => {
    const browserLanguage = useBrowserLanguage();

    const handleTranslate = async () => {
        await channel.translateUserMessage(
            message,
            [browserLanguage]
        ).then(response => {
            message.translations = response.translations;
            scrollToBottom();
        });
    }

    return (
        <MenuItem onClick={async () => {
            await handleTranslate();
        }}>
            Translate to {languageMap[browserLanguage] || browserLanguage}
        </MenuItem>
    );
};
